import { ListItemIcon, MenuItem } from '@mui/material';
import { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { StyledTheme } from '../../../styles/styleTheme';

interface CustomMenuItemLinkProps {
  to: string;
  primaryText: string;
  leftIcon?: ReactElement;
  onClick?: () => void;
}

const CustomMenuItemLink = ({ to, primaryText, leftIcon, onClick }: CustomMenuItemLinkProps) => {
  const { pathname } = useLocation();
  // Only highlight the menu item that exactly matches the current route
  const isActive = pathname === to;

  return (
    <MenuItem
      component={Link}
      to={to}
      onClick={onClick}
      sx={{
        color: isActive ? StyledTheme.tealDark : 'text.secondary',
        '& .MuiListItemIcon-root': {
          color: isActive ? StyledTheme.tealDark : 'text.secondary',
        },
      }}>
      {leftIcon && <ListItemIcon sx={{ minWidth: 5 }}>{leftIcon}</ListItemIcon>}
      {primaryText}
    </MenuItem>
  );
};

export default CustomMenuItemLink;
